import { render, staticRenderFns } from "./DocumentWClassification.vue?vue&type=template&id=140746ac"
import script from "./DocumentWClassification.vue?vue&type=script&lang=js"
export * from "./DocumentWClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports